import React, { useState } from 'react'
import './contact.css'
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import TextField from '@mui/material/TextField';
import { linkedinIcon, skypeIcon } from '../../lib/svgs/icons';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import {useSelector,useDispatch} from 'react-redux';
import { setContactusPopup } from '../../lib/redux/rootReducer';

const ContactUs = () => {
    const showContactUsForm = useSelector((state) => state.contactusPopup.value)
    const dispatch = useDispatch()
    const setShowContactUsForm = (value) => {
        dispatch(setContactusPopup(value))
    }
    const [formData, setFormData] = useState({})
    var formDataList = [
        {label:'Name*',mandatory:true,value:'name',type:'textfield'},
        {label:'Phone*',mandatory:true,value:'phone',type:'textfield'},
        {label:'Country*',mandatory:true,value:'country',type:'textfield'},
        {label:'Email*',mandatory:true,value:'email',type:'textfield'},
        {label:'Message*',mandatory:true,value:'message',type:'textfield',multiline:true,noOfRows:5},
    ]

    var otherPOC = [
        {label:'Pune, Maharastra',value:'location',icon:LocationOnIcon},
        // {label:'+917415010160',value:'phoneNumber',icon:CallIcon},
        {label:'contact@appvertiseads.com',value:'location',icon:EmailIcon},
        {label:'https://www.skype.com/sharemyprofile',value:'skype',icon:skypeIcon},
        {label:'https://www.linkedin.com/sharemyprofile',value:'linkedin',icon:linkedinIcon},
    ]
    
    var socialMediaPOC = [
        
    ]
    const inputStyle = { WebkitBoxShadow: "0 0 0 1000px white inset" ,fontSize: 15};

    return (
        <div className=''>
            {
                
                <div className='contactUsButtonStickyRight' onClick={()=>{setShowContactUsForm(true)}}>Contact Us</div>
            }
            <div className='contactUsContainer contactusFormContainer'  style={showContactUsForm ? {marginRight:'0px'} : {}}>
                <div className='cotactusheading'>
                    <IconButton onClick={()=>{setShowContactUsForm(false)}}>
                        <CloseIcon/>
                    </IconButton>
                    &nbsp;
                    <div> Contact Us</div>
                </div>
                <div className='contactFormItem' style={{marginBottom:'30px',marginTop:'10px'}}>
                    We are here to help you level up.
                </div>
                {formDataList.map((item,index)=>{
                    return <div className='contactFormItem' style={{transform:'scale(0.8)',transformOrigin:'left',marginBottom:'0px',marginTop:'5px'}} key={index}>
                            <TextField
                                inputProps={{ style: inputStyle }}
                                label={item.label} 
                                fullWidth
                                variant="outlined"
                                size='small'
                                multiline={item.multiline}
                                maxRows={item.multiline ? item.noOfRows : 1}
                                minRows={item.multiline ? item.noOfRows : 1}
                                rows={item.multiline ? item.noOfRows : 1}
                            />
                        </div>
                })}
                <div className='contactFormItem contactFormButton' style={{marginBottom:'30px',marginTop:'10px'}}>
                    Submit
                </div>
                <div style={{position:'relative',border:'0.01em solid rgb(200,200,200)',display:'flex',justifyContent:'center'}}>
                    <div style={{position:'absolute',marginTop:'-22px',padding:'16px',background:'white'}}>
                        OR
                    </div>
                    
                </div>
                <div className='contactFormItem' style={{marginBottom:'20px',marginTop:'20px',fontSize:'20px'}}>
                    Other point of contacts:
                </div>
                <div className='contactFormItem' >
                    {otherPOC.map((item,index)=>{
                        return <div key={index} style={{display:'flex',alignItems:'center',marginTop:'5px',marginBottom:'10px'}}>
                            <div style={{width:'30px'}}><item.icon/></div>
                            {item.label}
                            </div>
                    })}
                </div>
                <div className='contactFormItem'>
                    {socialMediaPOC.map((item,index)=>{
                        return <div key={index} style={{marginTop:'5px',marginBottom:'10px'}}>
                                <div>
                                    <item.icon/>
                                </div>
                            </div>
                    })}

                </div>
            </div>
        </div>
    )
}

export default ContactUs